export default __webpack_public_path__ + "static/media/timeline.0af5ffbf.svg";